import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "addressBookCard_container" }
const _hoisted_2 = { class: "cardTitle" }
const _hoisted_3 = { class: "deleteIcon" }
const _hoisted_4 = { class: "addressText" }
const _hoisted_5 = { class: "addressLabel" }
const _hoisted_6 = { class: "confirmPopTitle" }
const _hoisted_7 = { class: "buttonGroup" }

import StatusPopup from '@/components/common/statusPopup.vue';
import { deleteNetwork } from '@/view/withdraw/supportScript';
import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'addressBookCard',
  props: {
    address: {
        type: String,
        default: () => ''
    },
    channeLabel: {
        type: String,
        default: () => ''
    },
    chainType: {
        type: String,
        default: () => ''
    }
},
  emits: ['updateAddressBook'],
  setup(__props, { emit: __emit }) {

const props = __props
const emits = __emit
const show = ref(false)
const isSuccess = ref(false)
const toastContent = ref('')
const statusRef = ref()
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const deleteChannel = () => {
    show.value = true
}
const cancelDelete = () => {
    show.value = false
}
const confirmDelete = async () => {
    const { data } = await deleteNetwork(props.address)
    if (data.code == 200) {
        showSuccess(data.msg)
         emits('updateAddressBook')
    } else {
        showError(data)
    }

}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(__props.channeLabel), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_icon, {
          name: "delete-o",
          size: "18",
          onClick: deleteChannel
        })
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.address), 1),
      _createElementVNode("span", _hoisted_5, _toDisplayString(__props.chainType), 1)
    ]),
    _createVNode(_component_van_popup, {
      show: show.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
      class: "deleteConfirmPopup"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('withdraw.confirmDeleteAddress')), 1),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: "cancelBtn",
            onClick: cancelDelete
          }, _toDisplayString(_ctx.$t('withdraw.cancel')), 1),
          _createElementVNode("div", {
            class: "confirmBtn",
            onClick: confirmDelete
          }, _toDisplayString(_ctx.$t('withdraw.confirm')), 1)
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"])
  ], 64))
}
}

})